"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class CalculatorInbound extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'calculatorInbound';
        this._emailAddress = initParams.email_address;
        this._googlePlacesId = initParams.google_places_id;
        this._businessName = initParams.business_name;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set googlePlacesId(value) {
        console.error('Do not set objects this way');
    }
    get googlePlacesId() {
        return this._googlePlacesId;
    }
    set businessName(value) {
        console.error('Do not set objects this way');
    }
    get businessName() {
        return this._businessName;
    }
}
exports.default = CalculatorInbound;
//# sourceMappingURL=calculatorInbound.js.map